/**
 * Shared US phone number formatting + validation, used by any form field
 * that collects a phone number: format as (123) 456-7890 while typing,
 * and validate it's exactly 10 digits in that format before submit.
 */

export function formatPhoneNumber(value) {
  const digitsOnly = (value || "").replace(/\D/g, "");
  const limitedDigits = digitsOnly.slice(0, 10);
  if (limitedDigits.length <= 3) return limitedDigits;
  if (limitedDigits.length <= 6) {
    return `(${limitedDigits.slice(0, 3)}) ${limitedDigits.slice(3)}`;
  }
  return `(${limitedDigits.slice(0, 3)}) ${limitedDigits.slice(
    3,
    6,
  )}-${limitedDigits.slice(6)}`;
}

export function validatePhoneNumber(phone) {
  if (!phone || !phone.trim()) return null;
  const digitsOnly = phone.replace(/\D/g, "");
  if (digitsOnly.length !== 10) {
    return "Phone number must be exactly 10 digits in format (123) 123-1234";
  }
  const usPhoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
  if (!usPhoneRegex.test(phone.trim())) {
    return "Phone number must be in format (123) 123-1234";
  }
  return null;
}
